import { CoreMenu } from '@core/types';

export const menu: CoreMenu[] = [
  {
    id: 'switch',
    title: '',
    type: 'switch'
  },
  // market
  {
    id: 'market',
    type: 'section',
    title: 'MARKET',
    children: [
      {
        id: 'performance',
        type: 'item',
        title: 'Performance',
        icon: 'bar-chart-2',
        url: 'stock/performance'
      },
      {
        id: 'macro',
        type: 'item',
        title: 'Macro',
        icon: 'wind',
        url: 'stock/macro'
      },
      {
        id: 'fed-monitor',
        type: 'item',
        title: 'Fed Monitor',
        icon: 'monitor',
        url: 'stock/fed-monitor'
      },
      {
        id: 'toptrends',
        type: 'item',
        title: 'Daily Trends',
        icon: 'activity',
        url: 'stock/toptrends'
      },
      // {
      //   id: 'ideas',
      //   type: 'item',
      //   title: 'Ideas',
      //   icon: 'zap',
      //   url: 'stock/ideas'
      // },
      {
        id: 'atportfolio',
        type: 'item',
        title: 'AT Portfolio',
        icon: 'navigation-2',
        url: 'stock/atportfolio'
      }
    ]
  },

  // insights
  {
    id: 'insights',
    type: 'section',
    title: 'INSIGHTS',
    // translate: 'MENU.APPS.SECTION',
    // icon: 'package',
    children: [
      {
        id: 'ticker',
        type: 'ticker',
        title: 'ticker',
      },
      {
        id: 'summary',
        type: 'item',
        title: 'Summary',
        url: 'stock/summary',
        icon: 'clipboard',
        disabled: true
      },
      // {
      //   id: 'socialsignal',
      //   title: 'Social Signal',
      //   type: 'collapsible',
      //   icon: 'coffee',
      //   children: [
      //     {
      //       id: 'intraday',
      //       title: 'Intraday',
      //       type: 'item',
      //       icon: 'circle',
      //       url: 'stock/socialsignal',
      //       disabled: true,
      //     },
      //     // {
      //     //   id: 'historical',
      //     //   title: 'Historical',
      //     //   type: 'item',
      //     //   icon: 'circle',
      //     //   url: 'stock/historical',
      //     //   disabled: true,
      //     // },
      //   ]
      // },
      {
        id: 'technical',
        title: 'Technical',
        type: 'item',
        icon: 'trending-up',
        url: 'stock/technical',
        disabled: true,
      },
      {
        id: 'alternatives',
        title: 'Alternatives',
        type: 'item',
        icon: 'git-merge',
        url: 'stock/alternatives',
        disabled: true,
      },
      {
        id: 'operations',
        title: 'Operations',
        type: 'item',
        icon: 'cpu',
        url: 'stock/operations',
        disabled: true,
      },
      {
        id: 'valuation',
        title: 'Valuation',
        type: 'item',
        icon: 'box',
        url: 'stock/valuation',
        disabled: true,
      },
    ]
  },

  {
    id: 'mydashboard',
    type: 'section',
    title: 'MY DASHBOARD',
    children: [
      {
        id: 'myportfolio',
        type: 'item',
        title: 'My Portfolio',
        icon: 'paperclip',
        url: 'stock/portfolio'
      },
      {
        id: 'mywatchlist',
        type: 'item',
        title: 'My Watchlist',
        icon: 'eye',
        url: 'stock/watchlist'
      }
    ]
  }
];

export const crypto: CoreMenu[] = [
  {
    id: 'switch',
    title: '',
    type: 'switch'
  },
  {
    id: 'performance',
    type: 'item',
    title: 'Performance',
    icon: 'bar-chart-2',
    url: 'crypto/performance',
    classes: 'crypto-nav-item'
  },
  {
    id: 'toptrends',
    type: 'item',
    title: 'Daily Trends',
    icon: 'activity',
    url: 'crypto/toptrends',
    classes: 'crypto-nav-item'
  },
  {
    id: 'atportfolio',
    type: 'item',
    title: 'AT Portfolio',
    icon: 'navigation-2',
    url: 'crypto/atportfolio'
  },
  {
    id: 'myportfolio',
    type: 'item',
    title: 'My Portfolio',
    icon: 'paperclip',
    url: 'crypto/portfolio',
    classes: 'crypto-nav-item'
  },
  {
    id: 'mywatchlist',
    type: 'item',
    title: 'My Watchlist',
    icon: 'eye',
    url: 'crypto/watchlist',
    classes: 'crypto-nav-item'
  }
  // market
  // {
  //   id: 'market',
  //   type: 'section',
  //   title: 'MARKET',
  //   children: [
  //     {
  //       id: 'performance',
  //       type: 'item',
  //       title: 'Performance',
  //       icon: 'bar-chart-2',
  //       url: 'crypto/performance',
  //       classes: 'crypto-nav-item'
  //     },
  //     {
  //       id: 'toptrends',
  //       type: 'item',
  //       title: 'Daily Trends',
  //       icon: 'activity',
  //       url: 'crypto/toptrends',
  //       classes: 'crypto-nav-item'
  //     },
  //     {
  //       id: 'ideas',
  //       type: 'item',
  //       title: 'Ideas',
  //       icon: 'zap',
  //       url: 'crypto/ideas',
  //       classes: 'crypto-nav-item'
  //     }
  //   ]
  // },

  // insights
  // {
  //   id: 'insights',
  //   type: 'section',
  //   title: 'INSIGHTS',
  //   // translate: 'MENU.APPS.SECTION',
  //   // icon: 'package',
  //   children: [
  //     {
  //       id: 'crypto',
  //       type: 'crypto',
  //       title: 'crypto',
  //     },
  //     {
  //       id: 'summary',
  //       type: 'item',
  //       title: 'Summary',
  //       url: 'crypto/summary',
  //       icon: 'clipboard',
  //       disabled: true,
  //       classes: 'crypto-nav-item'
  //     },
  //     {
  //       id: 'socialsignal',
  //       title: 'Social Signal',
  //       type: 'collapsible',
  //       icon: 'coffee',
  //       classes: 'crypto-nav-item',
  //       children: [
  //         {
  //           id: 'cryptointraday',
  //           title: 'Intraday',
  //           type: 'item',
  //           icon: 'circle',
  //           url: 'crypto/socialsignal',
  //           disabled: true,
  //           classes: 'crypto-nav-item'
  //         },
  //         {
  //           id: 'cryptohistorical',
  //           title: 'Historical',
  //           type: 'item',
  //           icon: 'circle',
  //           url: 'crypto/historical',
  //           disabled: true,
  //           classes: 'crypto-nav-item'
  //         },
  //         {
  //           id: 'crypto-social-news',
  //           title: 'Social News',
  //           type: 'collapsible',
  //           icon: 'circle',
  //           children: [
  //             {
  //               id: 'twitter',
  //               title: 'Twitter',
  //               type: 'item',
  //               icon: 'circle',
  //               url: 'crypto/socialsentiment/twitter',
  //               disabled: true,
  //               classes: 'crypto-nav-item'
  //             },
  //             {
  //               id: 'stocktwitt',
  //               title: 'Stocktwits',
  //               type: 'item',
  //               icon: 'circle',
  //               url: 'crypto/socialsentiment/stocktwits',
  //               disabled: true,
  //               classes: 'crypto-nav-item'
  //             },
  //             // {
  //             //   id: 'news',
  //             //   title: 'News',
  //             //   type: 'item',
  //             //   icon: 'circle',
  //             //   url: 'news',
  //             //   disabled: true,
  //             // }
  //           ]
  //         },
  //       ]
  //     },
  //     {
  //       id: 'technical',
  //       title: 'Technical',
  //       type: 'item',
  //       icon: 'trending-up',
  //       url: 'crypto/technical',
  //       disabled: true,
  //       classes: 'crypto-nav-item'
  //     }
  //   ]
  // },
  // {
  //   id: 'mydashboard',
  //   type: 'section',
  //   title: 'MY DASHBOARD',
  //   children: [
  //     {
  //       id: 'myportfolio',
  //       type: 'item',
  //       title: 'My Portfolio',
  //       icon: 'paperclip',
  //       url: 'crypto/portfolio',
  //       classes: 'crypto-nav-item'
  //     },
  //     {
  //       id: 'mywatchlist',
  //       type: 'item',
  //       title: 'My Watchlist',
  //       icon: 'eye',
  //       url: 'crypto/watchlist',
  //       classes: 'crypto-nav-item'
  //     }
  //   ]
  // }
];

export const nft: CoreMenu[] = [
  // ON-CHAIN
  {
    id: 'on-chain',
    type: 'section',
    title: 'ON THE CHAIN',
    children: [
      {
        id: 'nft',
        type: 'nft',
        title: 'nft',
      },
      {
        id: 'trendingcollections',
        type: 'item',
        title: 'Trending Collections',
        icon: 'dollar-sign',
        url: 'nft/trendingcollections',
        classes: 'nft-nav-item'
      },
      {
        id: 'minting-now',
        type: 'item',
        title: 'Minting Now',
        icon: 'arrow-up',
        url: 'nft/mintingnow',
        classes: 'nft-nav-item'
      },
      // {
      //   id: 'utilitymode',
      //   type: 'item',
      //   title: 'Utility Mode',
      //   icon: 'paperclip',
      //   url: 'nft/utilitymode',
      //   classes: 'nft-nav-item'
      // },
    ]
  },

  // WALLETS
  {
    id: 'wallets',
    type: 'section',
    title: 'WALLETS',
    children: [
      {
        id: 'walletsearch',
        type: 'wallet',
        title: 'walletsearch',
      },
      {
        id: 'trendingwallets',
        type: 'item',
        title: 'Trending Wallets',
        icon: 'credit-card',
        url: 'nft/trendingwallets',
        classes: 'nft-nav-item'
      },
      {
        id: 'whalewallets',
        type: 'item',
        title: 'Whale Wallets',
        icon: 'user-check',
        url: 'nft/whalewallets',
        classes: 'nft-nav-item'
      }
    ]
  },

  // PRE-MINT
  // {
  //   id: 'pre-mint',
  //   type: 'section',
  //   title: 'PRE-MINT',
  //   children: [
  //     {
  //       id: 'launchingsoon',
  //       title: 'Launching Soon',
  //       type: 'item',
  //       icon: 'navigation',
  //       url: 'nft/launchingsoon',
  //       classes: 'nft-nav-item'
  //     },
  //     // {
  //     //   id: 'calender',
  //     //   title: 'Calender',
  //     //   type: 'item',
  //     //   icon: 'calendar',
  //     //   url: 'nft/calender',
  //     //   classes: 'nft-nav-item'
  //     // }
  //   ]
  // },

  /* PORTFOLIO */
  {
    id: 'myportfolio',
    type: 'section',
    title: 'MY PORTFOLIO',
    children: [
      {
        id: 'watchlist',
        type: 'item',
        title: 'My Watchlist',
        icon: 'eye',
        url: 'nft/watchlist',
        classes: 'nft-nav-item'
      },
      {
        id: 'mynotifications',
        type: 'item',
        title: 'Notifications',
        icon: 'bell',
        url: 'nft/notifications',
        classes: 'nft-nav-item'
      },
      {
        id: 'favwallets',
        type: 'item',
        title: 'Favorite Wallets',
        icon: 'framer',
        url: 'nft/favoritewallets',
        classes: 'nft-nav-item'
      },
      {
        id: 'myportfolio',
        type: 'clickable',
        title: 'My Portfolio',
        icon: 'pocket',
        url: 'nft/wallet',
        classes: 'nft-nav-item'
      },
      // {
      //   id: 'myperformance',
      //   type: 'item',
      //   title: 'My Performance',
      //   icon: 'activity',
      //   url: 'nft/myperformance',
      //   classes: 'nft-nav-item'
      // }
    ]
  }
];

export const help_menu: CoreMenu[] = [
  {
    id: 'help',
    type: 'section',
    title: 'LEARNING LAB',
    children: [
      {
        id: 'overview',
        title: 'Overview',
        type: 'item',
        icon: 'circle',
        url: 'help/overview'
      },
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'circle',
        url: 'help/dashboard'
      },
      {
        id: 'macro',
        title: 'Macro',
        type: 'item',
        icon: 'circle',
        url: 'help/macro'
      },
      {
        id: 'watchlist',
        title: 'Watchlist',
        type: 'item',
        icon: 'circle',
        url: 'help/watchlist'
      },
      {
        id: 'socialSignal',
        title: 'Social Signal',
        type: 'item',
        icon: 'circle',
        url: 'help/socialsignal'
      },
      {
        id: 'technical',
        title: 'Technical',
        type: 'item',
        icon: 'circle',
        url: 'help/technical'
      }
    ]
  }
]

export const admin_menu: CoreMenu[] = [
  {
    id: 'admin-section',
    type: 'section',
    title: 'ACTIONS',
    role: ['admin'],
    children: [
      {
        id: 'users',
        title: 'Users',
        type: 'item',
        icon: 'activity',
        url: '/admin'
      }
    ]
  }
];

